export default __webpack_public_path__ + "static/activities_image_four-45ef66cda1c61d8b0bd35d789f2a6d34.png";